<template>
  <v-container>
    <v-rating
      hover
      v-model="rating"
      length="5"
      :disabled="disabled"
      :background-color="color"
      class="pb-4"
      data-test-rating
      :label="$t(feedBackPlaceholder)"
    ></v-rating>

    <v-textarea
      clearable
      auto-grow
      outlined
      :label="$t(feedBackPlaceholder)"
      v-model.lazy="message"
      :disabled="disabled"
      data-test-feedback-description
    ></v-textarea>

    <v-btn
      @click="sendFeedback"
      class="feedback-button"
      color="success"
      rounded
      large
      :disabled="!isDone"
      :loading="isLoading"
      data-test-submit-feedback-button
    >
      <v-icon left> mdi-send </v-icon>
      {{ $t("components.feedback.send") }}
    </v-btn>
  </v-container>
</template>

<style scoped></style>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { PartnerModule } from "@/store/modules/partner";
import { RatingEntity } from "@/models/ratingEntitity";

@Component({
  components: {}
})
export default class FeedbackContainer extends Vue {
  @Prop({ default: "components.feedback.placeholder" })
  feedBackPlaceholder!: string;

  @Prop({ default: 0 })
  rating!: number;

  @Prop({})
  keyForEndpoint!: string;

  message = "";
  isLoading = false;

  get partner() {
    return PartnerModule.partner;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isDone() {
    return this.rating > 0 && !this.disabled;
  }

  get disabled() {
    return !PartnerModule.isRatingSubmissionEnabled;
  }

  async sendFeedback() {
    this.isLoading = true;

    const rating: RatingEntity = {
      key: this.keyForEndpoint,
      rating: this.rating,
      message: this.message
    };

    try {
      await PartnerModule.addRatingForPartner(rating);
      this.$emit("sent");
    } catch (error) {
      Vue.$log.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
